import { Action } from '@ngrx/store';

export const VISIBLE_PANELD = '[PANEL_DATOS] Visible';
export const HIDDEN_PANELD = '[PANEL_DATOS] HIDDEN';


export class VisiblePDAction implements Action {
  readonly type = VISIBLE_PANELD;
  constructor() {}
}

export class HiddenPDAction implements Action {
  readonly type = HIDDEN_PANELD;
  constructor() {}
}

export type PCActions =
  | VisiblePDAction
  | HiddenPDAction;
